import React, { useState, useEffect } from 'react';

function GeoLocation({ setLatitude, setLongitude }) {
    const [geo, setGeo] = useState(
        {
            lat: '',
            lng: ''
        }
    );


    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log('position', position);
                    setGeo({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                },
                (err) => {
                    console.log('error', err);
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, []);

    return (
        <div>
            <h1>Current Location</h1>
            <p>Latitude: {geo.lat}</p>
            <p>Longitude: {geo.lng}</p>
        </div>
    );
}

export default GeoLocation;
